var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFillStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3925 10.7033C13.1989 10.891 13.1099 11.1623 13.154 11.4284L13.8185 15.1057C13.8746 15.4174 13.743 15.7328 13.4822 15.913C13.2265 16.0998 12.8865 16.1223 12.6077 15.9728L9.29728 14.2462C9.18217 14.1849 9.05436 14.152 8.92356 14.1483H8.721C8.65075 14.1587 8.58198 14.1812 8.5192 14.2155L5.20806 15.9503C5.04437 16.0326 4.859 16.0617 4.67738 16.0326C4.23489 15.9488 3.93966 15.5273 4.01216 15.0826L4.67738 11.4052C4.72148 11.1369 4.63253 10.864 4.43894 10.6734L1.73995 8.05742C1.51423 7.83842 1.43575 7.50955 1.53889 7.21282C1.63905 6.91683 1.89467 6.70083 2.20336 6.65224L5.91812 6.11334C6.20065 6.08419 6.4488 5.91228 6.57586 5.65815L8.21275 2.30217C8.25161 2.22742 8.30169 2.15866 8.36224 2.10036L8.4295 2.04804C8.46463 2.00917 8.505 1.97703 8.54984 1.95087L8.63131 1.92097L8.75838 1.86865H9.07305C9.35408 1.8978 9.60148 2.06598 9.73079 2.31711L11.3894 5.65815C11.5089 5.90256 11.7414 6.07223 12.0097 6.11334L15.7245 6.65224C16.0384 6.69709 16.3008 6.91384 16.4046 7.21282C16.5026 7.51254 16.4181 7.84141 16.1879 8.05742L13.3925 10.7033Z",
    fill: "#EED201"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFillStar);
export default __webpack_public_path__ + "static/media/fill-star.5e4db154cfde3c996c56d7e939b4b339.svg";
export { ForwardRef as ReactComponent };